import React, { useEffect } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getServiceBySlug } from '../data/services';

function ServicePage() {
  const { slug } = useParams();
  const service = getServiceBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!service) {
    return <Navigate to="/" replace />;
  }

  const { title, icon, metaTitle, metaDescription, content } = service;

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <link rel="canonical" href={`${window.location.origin}/services/${slug}`} />
      </Helmet>

      <main>
        <section className="service-page">
          <div className="service-page-decor">
            <span className="decor-sym">✨</span>
            <span className="decor-sym">🌙</span>
            <span className="decor-sym">⭐</span>
            <span className="decor-sym">🔮</span>
          </div>
          <div className="container">
            <nav className="breadcrumb" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span className="breadcrumb-sep">/</span>
              <Link to="/#services">Services</Link>
              <span className="breadcrumb-sep">/</span>
              <span aria-current="page">{title}</span>
            </nav>

            <header className="service-page-header">
              <div className="service-page-icon">{icon}</div>
              <div className="section-ornament">
                <span>✧</span>
                <span>◆</span>
                <span>✧</span>
              </div>
              <h1 className="service-page-title">{title}</h1>
              <p className="service-page-intro">{content.intro}</p>
            </header>

            <article className="service-page-content">
              {content.sections.map((section, index) => (
                <section key={index} className="service-content-section">
                  <h2>{section.heading}</h2>
                  <p>
                    {section.text}
                    {section.text2 && <><br />{section.text2}</>}
                  </p>
                </section>
              ))}
            </article>

            <div className="service-page-cta">
              <p>Ready to experience {title.toLowerCase()}?</p>
              <a href="/#contact" className="cta-button primary">Book a Session</a>
              <a href="/#services" className="cta-button secondary">View All Services</a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default ServicePage;
